import { Link } from '@solidjs/meta';
import { Setting, setting } from '@bz/request';

export function themeCssUrl(theme: Setting.Theme | undefined) {
  switch (theme) {
    case Setting.Theme.cool:
      return '/SIR/SIR_cool_theme.css';
    case Setting.Theme.bakos:
      return '/SIR/SIR_bakos_theme.css';
    case Setting.Theme.plaster:
      return '/SIR/SIR_plaster_theme.css';
    default:
      return '/SIR/SIR_cool_theme.css';
  }
}

function WidgetLink() {
  const cssLinkUrl = createMemo(() => {
    return themeCssUrl(setting.theme as Setting.Theme | undefined);
  });

  return (
    <>
      <Show when={!isServer}>
        <Link rel="stylesheet" type="text/css" href={cssLinkUrl()}></Link>
      </Show>
    </>
  );
}

export default WidgetLink;
